<template lang="pug">
div
  .options-sheet
    shActionButton(v-if="!old" :action="toggleView" text="Cambiar a Hoja Carta" textRunning="Desempacando")
    shActionButton(v-else :action="toggleView" text="Cambiar a Etiqueta" textRunning="Desempacando")
  .sheet-orders(v-if="!old")
    shOrderPrintReturnAddress(v-for="(order, index) in orders" :order="order" :width="width" :height="height" :key="order.order" :remitOnly="returnAddressRemitOnly" v-if="order.checked && index % 2 === 0")
    shOrderPrintReturnAddress(v-for="(order, index) in orders" :order="order" :width="width" :height="height" :key="order.order" :remitOnly="returnAddressRemitOnly" v-if="order.checked && index % 2 !== 0" :pageBreak="true")
    shChangePrintReturnAddress(v-for="(change, index) in changes" :change="change" :width="width" :height="height" :key="change.change" :remitOnly="returnAddressRemitOnly" v-if="change.checked && index % 2 === 0")
    shChangePrintReturnAddress(v-for="(change, index) in changes" :change="change" :width="width" :height="height" :key="change.change" :remitOnly="returnAddressRemitOnly" v-if="change.checked && index % 2 !== 0" :pageBreak="true")
  .sheet-orders(v-else)
    shOrderPrintReturnAddressOld(v-for="order in orders" :order="order" :key="order.order" :remitOnly="returnAddressRemitOnly" v-if="order.checked")
    shChangePrintReturnAddressOld(v-for="change in changes" :change="change" :key="change.change" :remitOnly="returnAddressRemitOnly" v-if="change.checked")
</template>

<script>
import shOrderPrintReturnAddress from './OrderPrintReturnAddress.vue'
import shChangePrintReturnAddress from './ChangePrintReturnAddress.vue'
import shOrderPrintReturnAddressOld from './OrderPrintReturnAddressOld.vue'
import shChangePrintReturnAddressOld from './ChangePrintReturnAddressOld.vue'
import shForm from '../../../mixins/form'

export default {
  name: 'PrintReturnAddress',

  mixins: [ shForm ],

  components: { shOrderPrintReturnAddress, shChangePrintReturnAddress, shOrderPrintReturnAddressOld, shChangePrintReturnAddressOld },

  data () {
    return {
      old: false,
      width: '10cm',
      height: '5cm'
    }
  },

  methods: {
    toggleView () {
      this.old = !this.old
    }
  },

  beforeDestroy () {
    this.$store.commit('clearPrintReturnAddress')
  },

  computed: {
    orders () {
      const printOrders = this.$store.state.print.returnAddressOrders

      if (printOrders && printOrders.length) {
        return printOrders.map(order => ({ ...order, checked: true }))
      }

      return this.$store.state.data.orders.data.docs
    },
    changes () {
      const printChanges = this.$store.state.print.returnAddressChanges

      if (printChanges && printChanges.length) {
        return printChanges.map(change => ({ ...change, checked: true }))
      }

      return this.$store.state.data.changes.data.docs
    },
    returnAddressRemitOnly () {
      return this.$store.state.print.returnAddressRemitOnly
    }
  }
}
</script>

<style lang="stylus" scope>
.sheet-orders
  text-align left
  position relative
  background-color white

.options-sheet
  display flex
  align-items center
  justify-content center
  gap 1em
  margin-bottom 1em

@media print
  .container, body
    padding 0
    margin 0
    background-color white

  .options-sheet
    display none
</style>



// WEBPACK FOOTER //
// src/components/pages/print/PrintReturnAddress.vue